import { Notification } from "@cnx/common";
import { Box, Flex, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconAlertOctagon } from "@tabler/icons-react";
import ChangeViewer from "../NotificationCard/NotificationCardPreview/ChangeViewer";
import NotificationTitle from "../NotificationTitle";

interface ImportantNotificationModalProps {
  notification: Notification;
}

const ImportantNotificationModal: React.FC<ImportantNotificationModalProps> = ({
  notification,
}) => {
  const [opened, { close }] = useDisclosure(true);

  return (
    <Modal
      fullScreen
      withCloseButton={false}
      classNames={{ body: "!p-0" }}
      opened={opened}
      onClose={close}
    >
      <Flex direction={"column"} className="min-h-screen">
        <Flex gap={"md"} justify={"space-between"}>
          <Flex
            mih={66}
            px={14}
            className="border-b border-gray w-full"
            align={"center"}
            justify={"space-between"}
          >
            <Flex gap={"lg"} align={"center"}>
              <Box component="a" className="group/button">
                <IconAlertOctagon
                  className="text-red-dark"
                  width={24}
                  height={24}
                />
              </Box>
              <NotificationTitle
                title={notification.title}
                notificationTypeName={notification.notificationTypeName.toUpperCase()}
                trailerLicenceNumber={notification.trailerLicenceNumber}
              />
            </Flex>
          </Flex>
        </Flex>
        <Box className="flex flex-col flex-1">
          <ChangeViewer goBack={close} notification={notification} />
        </Box>
      </Flex>
    </Modal>
  );
};

export default ImportantNotificationModal;
